export const convertDataToForm = (data) => ({
  email: data.email.toLowerCase(),
  password: data.password,
});
